import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Therapy from "@/components/Therapy";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import { useLanguage } from "@/i18n/LanguageContext";

const DornBreuss = () => {
    const { t } = useLanguage();
    const seo = t.page_meta.seo.therapy;

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <div data-testid="dorn-breuss-page" className="bg-ella-cream min-h-screen">
            <Header />
            <PageMeta title={seo.title} h1={seo.h1} description={seo.description} />
            <main className="pt-32 md:pt-40">
                <div className="ella-container">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-ella-muted hover:text-ella-ink transition-colors"
                        data-testid="dorn-breuss-back-home"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
                        {t.page_meta.back_home}
                    </Link>
                </div>

                <Therapy />
            </main>
            <Footer />
        </div>
    );
};

export default DornBreuss;
